import { ref } from "vue";

const isModalVisible = ref(false);
const showModal = (options?: Partial<typeof modalOpts>) => {
  isModalVisible.value = true;
  modalOptions.value = Object.assign(modalOptions.value, options || {});
};

const hideModal = () => {
  isModalVisible.value = false;
};
const modalOpts = {
  title: "Modal",
  text: "",
  oncancel: hideModal,
  onsubmit: hideModal,
  ongetallentity: hideModal,
  ondrawline: hideModal,
  docommand:(cmd)=>{}
}

const modalOptions = ref(modalOpts)
export const useModalVisible = ()=> {
  return {
    isModalVisible,
    showModal,
    hideModal,
    modalOptions
  }
}

